<template>
  <div class="">

    <Head />

    <div class="main listMain form">

      <AccesskeyLink target="accesskey_c" accesskey="c" :aria-label="$t('跳到中央內容區塊')">
        {{ $t(':::') }}
      </AccesskeyLink>

      <!-- 毛毛蟲 -->
      <nav aria-label="breadcrumb" class="breadcrumb_box">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
            <li class="breadcrumb-item" v-if="firstCategory"><router-link :to="`/Category/${firstCategory.cId}`" :title="firstCategory.title">{{ firstCategory.title }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ mainTitle }}</li>
          </ol>
        </div>
      </nav>

      <div class="listMain_box">
        <div class="container">

          <div class="title_box">
            <h2>{{ mainTitle }}</h2>
            <div class="time_social">
              <p>{{ time }}</p>

              <div class="social_box">
                <a class="social" v-for="item in socialItem" :key="item.title" href="#" @click.prevent="item.action"
                  :title="item.title">
                  <img :src="item.src" :alt="item.title">
                </a>
              </div>

            </div>
          </div>

          <div class="box">

            <VueSlickCarousel v-if="carouselItems.length > 0" class="carousel_box" :slidesToShow="1"
              :focusOnSelect="true" :autoplay="false" :arrows="true" :dots="true" :swipe="true" :draggable="true">
              <div v-for="(carousel, index) in carouselItems" :key="index">
                <div class="img_box" :style="{ backgroundImage: `url(${carousel.src})` }">
                  <img :src="carousel.src" :alt="carousel.title" />
                </div>
              </div>
            </VueSlickCarousel>

            <div class="text_box" v-html="postContent"></div>


            <div v-if="downloadItems.length > 0" class="download_box">
              <h3>{{ $t('檔案下載') }}</h3>

              <ul class="download_list">
                <li v-for="item in downloadItems" :key="item.id">
                  <a class="download" :href="item.href" :title="item.title + '（另開新視窗）'" target="_blank">
                    <p>
                      <span class="title">{{ item.title }} </span>
                      <span class="file">{{ item.file }}</span>
                    </p>
                  </a>
                </li>
              </ul>
            </div>

            <!-- 表單區塊 -->
            <div v-if="formData && formData.isAvailable" class="form_box">
              <div v-if="formData.isReachLimit" class="alert alert-warning">
                {{ $t('此表單已達填寫上限，無法繼續填寫。') }}
              </div>

              <form v-else @submit.prevent="submitForm" class="post_form">
                <div v-for="field in formData.fields" :key="field.ffId" class="group">
                  <label :for="`field_${field.ffId}`" class="form-label">
                    {{ field.label }}
                    <span v-if="field.isRequired" class="required">{{ $t('（必填）') }}</span>
                  </label>

                  <!-- 文字輸入 -->
                  <div v-if="field.fieldType === 1">
                    <input 
                      :id="`field_${field.ffId}`"
                      type="text" 
                      v-model="formValues[field.ffId]"
                      :placeholder="field.placeholder"
                      :required="field.isRequired"
                      :maxlength="field.maxLength > 0 ? field.maxLength : null"
                      class="form-control"
                    />
                    <p v-if="field.maxLength > 0" :class="['word_limit', { full: (formValues[field.ffId] || '').length >= field.maxLength }]">
                      {{ (formValues[field.ffId] || '').length }} / {{ field.maxLength }}
                    </p>
                    <span v-if="fieldErrors[field.ffId]" class="error_msg">{{ fieldErrors[field.ffId] }}</span>
                  </div>

                  <!-- 多選 -->
                  <div v-else-if="field.fieldType === 2">
                    <div class="check_box">
                      <div v-for="(option, idx) in field.options" :key="idx" class="form-check">
                        <input 
                          :id="`field_${field.ffId}_${idx}`"
                          type="checkbox" 
                          :value="option"
                          v-model="formValues[field.ffId]"
                          class="form-check-input"
                        />
                        <label class="form-check-label" :for="`field_${field.ffId}_${idx}`">{{ option }}</label>
                      </div>
                      <!-- 其他選項 -->
                      <div v-if="field.hasOtherOption" class="form-check">
                        <input 
                          :id="`field_${field.ffId}_other`"
                          type="checkbox" 
                          value="__OTHER__"
                          v-model="formValues[field.ffId]"
                          class="form-check-input"
                        />
                        <label class="form-check-label" :for="`field_${field.ffId}_other`">{{ $t('其他') }}</label>
                      </div>
                    </div>
                    <!-- 其他選項輸入框 -->
                    <div v-if="field.hasOtherOption && formValues[field.ffId] && formValues[field.ffId].includes('__OTHER__')" class="other_input_box">
                      <input 
                        type="text" 
                        v-model="formOtherValues[field.ffId]"
                        :placeholder="$t('請輸入其他內容')"
                        class="form-control"
                      />
                    </div>
                    <span v-if="fieldErrors[field.ffId]" class="error_msg">{{ fieldErrors[field.ffId] }}</span>
                  </div>

                  <!-- 單選 -->
                  <div v-else-if="field.fieldType === 3">
                    <div class="check_box">
                      <div v-if="!field.isRequired" class="form-check">
                        <input 
                          :id="`field_${field.ffId}_none`"
                          type="radio" 
                          value=""
                          v-model="formValues[field.ffId]"
                          class="form-check-input"
                          :name="`field_${field.ffId}`"
                        />
                        <label class="form-check-label" :for="`field_${field.ffId}_none`">{{ $t('未選擇') }}</label>
                      </div>
                      <div v-for="(option, idx) in field.options" :key="idx" class="form-check">
                        <input 
                          :id="`field_${field.ffId}_${idx}`"
                          type="radio" 
                          :value="option"
                          v-model="formValues[field.ffId]"
                          :required="field.isRequired"
                          class="form-check-input"
                          :name="`field_${field.ffId}`"
                        />
                        <label class="form-check-label" :for="`field_${field.ffId}_${idx}`">{{ option }}</label>
                      </div>
                      <!-- 其他選項 -->
                      <div v-if="field.hasOtherOption" class="form-check">
                        <input 
                          :id="`field_${field.ffId}_other`"
                          type="radio" 
                          value="__OTHER__"
                          v-model="formValues[field.ffId]"
                          class="form-check-input"
                          :name="`field_${field.ffId}`"
                        />
                        <label class="form-check-label" :for="`field_${field.ffId}_other`">{{ $t('其他') }}</label>
                      </div>
                    </div>
                    <!-- 其他選項輸入框 -->
                    <div v-if="field.hasOtherOption && formValues[field.ffId] === '__OTHER__'" class="other_input_box">
                      <input 
                        type="text" 
                        v-model="formOtherValues[field.ffId]"
                        :placeholder="$t('請輸入其他內容')"
                        class="form-control"
                      />
                    </div>
                    <span v-if="fieldErrors[field.ffId]" class="error_msg">{{ fieldErrors[field.ffId] }}</span>
                  </div>

                  <!-- 多行文字 -->
                  <div v-else-if="field.fieldType === 4">
                    <textarea 
                      :id="`field_${field.ffId}`"
                      v-model="formValues[field.ffId]"
                      :placeholder="field.placeholder"
                      :required="field.isRequired"
                      :maxlength="field.maxLength > 0 ? field.maxLength : null"
                      rows="3"
                      class="form-control"
                    ></textarea>
                    <p v-if="field.maxLength > 0" :class="['word_limit', { full: (formValues[field.ffId] || '').length >= field.maxLength }]">
                      {{ (formValues[field.ffId] || '').length }} / {{ field.maxLength }}
                    </p>
                    <span v-if="fieldErrors[field.ffId]" class="error_msg">{{ fieldErrors[field.ffId] }}</span>
                  </div>

                  <!-- 檔案上傳 -->
                  <div v-else-if="field.fieldType === 5">
                    <input 
                      :id="`field_${field.ffId}`"
                      type="file" 
                      @change="handleFileChange($event, field)"
                      :required="field.isRequired"
                      :accept="field.allowedFileTypes"
                      class="form-control"
                    />
                    <div v-if="field.maxFileSize || field.allowedFileTypes" class="form_text">
                      <span v-if="field.maxFileSize">{{ $t('檔案大小限制：') }}{{ field.maxFileSize }}{{ $t('MB') }}</span>
                      <span v-if="field.allowedFileTypes" class="ms-2">{{ $t('允許類型：') }}{{ field.allowedFileTypes }}</span>
                    </div>
                    <span v-if="fieldErrors[field.ffId]" class="error_msg">{{ fieldErrors[field.ffId] }}</span>
                  </div>

                  <!-- 數字輸入 -->
                  <div v-else-if="field.fieldType === 6">
                    <input 
                      :id="`field_${field.ffId}`"
                      type="number" 
                      v-model.number="formValues[field.ffId]"
                      :placeholder="field.placeholder"
                      :required="field.isRequired"
                      :min="field.minValue !== null && field.minValue !== undefined ? field.minValue : null"
                      :max="field.maxValue !== null && field.maxValue !== undefined ? field.maxValue : null"
                      class="form-control"
                    />
                    <div v-if="field.minValue !== null && field.minValue !== undefined || field.maxValue !== null && field.maxValue !== undefined" class="form_text">
                      <span v-if="field.minValue !== null && field.minValue !== undefined">{{ $t('最小值：') }}{{ field.minValue }}</span>
                      <span v-if="field.maxValue !== null && field.maxValue !== undefined" :class="{'ms-2': field.minValue !== null && field.minValue !== undefined}">{{ $t('最大值：') }}{{ field.maxValue }}</span>
                    </div>
                    <span v-if="fieldErrors[field.ffId]" class="error_msg">{{ fieldErrors[field.ffId] }}</span>
                  </div>
                </div>

                <div class="btn_box">
                  <button type="submit" class="send_btn" :disabled="isSubmitting">
                    {{ isSubmitting ? $t('送出中...') : $t('送出') }}
                  </button>
                </div>
              </form>
            </div>

          </div>


        </div>
      </div>

    </div>

    <Footer />

  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue';

import AccesskeyLink from '@/views/AccesskeyLink.vue'

// 輪播
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

// SweetAlert2
import Swal from 'sweetalert2'

export default {
  name: 'Post',
  components: {
    Head,
    Footer,

    AccesskeyLink,

    VueSlickCarousel,
  },

  data() {
    return {

      mainTitle: "",
      time: "",
      postContent: "",
      categories: [],
      firstCategory: null,

      // 社交軟體
      socialItem: [
        {
          title: this.$t('分享'),
          src: require('/public/img/fb_blue.svg'),
          action: this.sharePost
        },
        {
          title: this.$t('分享至X（另開新視窗）'),
          src: require('/public/img/twitter_blue.svg'),
          action: this.shareToX
        },
        {
          title: this.$t('分享至FB（另開新視窗）'),
          src: require('/public/img/share_blue.svg'),
          action: this.shareToFB
        },
      ],

      // 輪播
      carouselItems: [],

      // 下載項目
      downloadItems: [],

      // 表單相關
      formData: null,
      formValues: {},
      formOtherValues: {},
      fieldErrors: {},
      isSubmitting: false

    };
  },

  async mounted() {
    // 從路由取得 PId
    const pId = this.$route.params.PId;

    if (pId) {
      await this.fetchPostData(pId);
    } else {
      console.error('缺少文章 ID');
    }
  },

  watch: {
    // 監聽路由參數變化，當 PId 改變時重新載入資料
    '$route.params.PId': {
      handler(newPId) {
        if (newPId) {
          this.fetchPostData(newPId);
        }
      },
      immediate: false
    },
    // 監聽語系變化，當語系改變時重新載入資料
    '$i18n.locale': async function() {
      const pId = this.$route.params.PId;
      if (pId) {
        await this.fetchPostData(pId);
      }
    }
  },

  methods: {
    // 轉換前端語系名稱為後端格式
    convertLocaleForBackend(frontendLocale) {
      const localeMap = {
        'zh-TW': 'zh-tw',
        'en': 'en-us',
        'ja': 'ja-jp'
      };
      return localeMap[frontendLocale] || 'zh-tw';
    },

    // API: 取得文章資料
    async fetchPostData(pId) {
      // 切換文章前先重置所有資料，避免舊資料殘留
      this.mainTitle = '';
      this.time = '';
      this.postContent = '';
      this.categories = [];
      this.firstCategory = null;
      this.carouselItems = [];
      this.downloadItems = [];
      this.formData = null;

      try {
        const backendLocale = this.convertLocaleForBackend(this.$i18n.locale);
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetPostData?PId=${pId}&locale=${backendLocale}`;
        const response = await fetch(apiUrl);

        if (!response.ok) {
          console.error('載入文章資料失敗:', response.status);
          return;
        }

        const post = await response.json();

        // 設定文章基本資訊
        this.mainTitle = post.title || '';
        this.time = this.formatDate(post.publicStartTime);
        this.postContent = this.processContentUrls(post.content || '');

        // 處理 Categories
        if (post.categories && Array.isArray(post.categories) && post.categories.length > 0) {
          this.categories = post.categories;
          this.firstCategory = post.categories[0];
        } else {
          this.categories = [];
          this.firstCategory = null;
        }

        // 處理 Slideshow（已為陣列物件）
        if (post.slideshow && Array.isArray(post.slideshow) && post.slideshow.length > 0) {
          this.carouselItems = post.slideshow.map(slide => ({
            src: `${this.$store.state.src}${this.$store.state.subDirectory}${slide.filePath}` || '',
            title: slide.displayName || slide.name || this.mainTitle
          }));
        }

        // 處理 Attachment（已為陣列物件或單一檔案路徑）
        if (post.attachment) {
          if (Array.isArray(post.attachment)) {
            // 陣列格式
            this.downloadItems = post.attachment.map((att, index) => ({
              id: index + 1,
              title: att.displayName || att.name || `${this.$t('附件')} ${index + 1}`,
              file: this.getFileExtension(att.extension || ''),
              href: `${this.$store.state.src}${this.$store.state.subDirectory}${att.filePath}` || '#'
            }));
          } else if (typeof post.attachment === 'string') {
            // 字串格式（單一檔案路徑）
            this.downloadItems = [{
              id: 1,
              title: this.$t('檔案下載'),
              file: this.getFileExtension(post.attachment),
              href: post.attachment
            }];
          }
        }

        // 處理表單資料
        if (post.form) {
          this.formData = post.form;
          this.initializeFormValues();
        } else {
          this.formData = null;
        }

      } catch (error) {
        console.error('載入文章資料失敗:', error);
      }
    },

    // 初始化表單值
    initializeFormValues() {
      this.formValues = {};
      this.formOtherValues = {};
      this.fieldErrors = {};
      
      if (this.formData && this.formData.fields) {
        this.formData.fields.forEach(field => {
          // 多選欄位初始化為陣列
          if (field.fieldType === 2) {
            this.$set(this.formValues, field.ffId, []);
          } 
          // 數字欄位初始化為預設值或空字串
          else if (field.fieldType === 6) {
            this.$set(this.formValues, field.ffId, field.defaultValue !== null && field.defaultValue !== undefined ? field.defaultValue : '');
          } 
          else {
            this.$set(this.formValues, field.ffId, '');
          }
          
          // 初始化「其他」選項的值
          if (field.hasOtherOption) {
            this.$set(this.formOtherValues, field.ffId, '');
          }
        });
      }
      console.log('Form values initialized:', this.formValues);
    },

    // 獲取欄位字數
    getFieldLength(ffId) {
      const value = this.formValues[ffId];
      const length = value ? value.length : 0;
      console.log(`getFieldLength called - ffId: ${ffId}, value:`, value, `length: ${length}`);
      console.log('Current formValues:', this.formValues);
      return length;
    },

    // 處理檔案選擇
    handleFileChange(event, field) {
      const file = event.target.files[0];
      if (!file) {
        this.formValues[field.ffId] = null;
        return;
      }

      // 驗證檔案大小
      if (field.maxFileSize && file.size > field.maxFileSize * 1024 * 1024) {
        this.fieldErrors[field.ffId] = `${this.$t('檔案大小不可超過')} ${field.maxFileSize}${this.$t('MB')}`;
        event.target.value = '';
        this.formValues[field.ffId] = null;
        return;
      }

      // 驗證檔案類型
      if (field.allowedFileTypes) {
        const allowedTypes = field.allowedFileTypes.toLowerCase().split(',').map(t => t.trim());
        const fileExt = '.' + file.name.split('.').pop().toLowerCase();
        if (!allowedTypes.includes(fileExt)) {
          this.fieldErrors[field.ffId] = `${this.$t('僅允許上傳')} ${field.allowedFileTypes} ${this.$t('格式的檔案')}`;
          event.target.value = '';
          this.formValues[field.ffId] = null;
          return;
        }
      }

      this.fieldErrors[field.ffId] = '';
      this.formValues[field.ffId] = file;
    },

    // 驗證表單
    validateForm() {
      this.fieldErrors = {};
      let isValid = true;

      this.formData.fields.forEach(field => {
        const value = this.formValues[field.ffId];

        // 必填驗證
        if (field.isRequired) {
          if (field.fieldType === 2) {
            // 多選
            if (!value || value.length === 0) {
              this.fieldErrors[field.ffId] = this.$t('此欄位為必填');
              isValid = false;
            }
          } else if (!value || (typeof value === 'string' && value.trim() === '')) {
            this.fieldErrors[field.ffId] = this.$t('此欄位為必填');
            isValid = false;
          }
        }

        // 檢查「其他」選項是否有填寫內容
        if (field.fieldType === 2 && field.hasOtherOption && Array.isArray(value) && value.includes('__OTHER__')) {
          if (!this.formOtherValues[field.ffId] || this.formOtherValues[field.ffId].trim() === '') {
            this.fieldErrors[field.ffId] = this.$t('請輸入其他內容');
            isValid = false;
          }
        }

        if (field.fieldType === 3 && field.hasOtherOption && value === '__OTHER__') {
          if (!this.formOtherValues[field.ffId] || this.formOtherValues[field.ffId].trim() === '') {
            this.fieldErrors[field.ffId] = this.$t('請輸入其他內容');
            isValid = false;
          }
        }

        // 文字輸入特殊驗證
        if (field.fieldType === 1 && value && field.validationRule) {
          if (field.validationRule === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
              this.fieldErrors[field.ffId] = this.$t('請輸入有效的電子郵件地址');
              isValid = false;
            }
          } else if (field.validationRule === 'url') {
            const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
            if (!urlRegex.test(value)) {
              this.fieldErrors[field.ffId] = this.$t('請輸入有效的網址');
              isValid = false;
            }
          } else if (field.validationRule === 'regex' && field.validationPattern) {
            try {
              const regex = new RegExp(field.validationPattern);
              if (!regex.test(value)) {
                this.fieldErrors[field.ffId] = this.$t('輸入格式不正確');
                isValid = false;
              }
            } catch (e) {
              console.error('正規表達式錯誤:', e);
            }
          }
        }

        // 數字輸入驗證
        if (field.fieldType === 6 && value !== '' && value !== null && value !== undefined) {
          const numValue = Number(value);
          
          // 檢查是否為有效數字
          if (isNaN(numValue)) {
            this.fieldErrors[field.ffId] = this.$t('請輸入有效的數字');
            isValid = false;
          } else {
            // 檢查最小值
            if (field.minValue !== null && field.minValue !== undefined && numValue < field.minValue) {
              this.fieldErrors[field.ffId] = `${this.$t('數字不可小於')} ${field.minValue}`;
              isValid = false;
            }
            // 檢查最大值
            if (field.maxValue !== null && field.maxValue !== undefined && numValue > field.maxValue) {
              this.fieldErrors[field.ffId] = `${this.$t('數字不可大於')} ${field.maxValue}`;
              isValid = false;
            }
          }
        }
      });

      return isValid;
    },

    // 將檔案轉換為 Base64
    async fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
        reader.readAsDataURL(file);
      });
    },

    // 送出表單
    async submitForm() {
      // 驗證表單
      if (!this.validateForm()) {
        await Swal.fire({
          title: this.$t('驗證失敗'),
          text: this.$t('請檢查表單內容'),
          icon: 'warning',
          confirmButtonText: this.$t('確定')
        });
        return;
      }

      this.isSubmitting = true;

      try {
        const fieldData = [];

        // 處理所有欄位資料
        for (const field of this.formData.fields) {
          const value = this.formValues[field.ffId];

          if (field.fieldType === 5 && value instanceof File) {
            // 檔案上傳 - 轉換為 Base64
            try {
              const base64 = await this.fileToBase64(value);
              fieldData.push({
                ffId: field.ffId,
                value: base64,
                fileName: value.name,
                filePath: null
              });
            } catch (error) {
              console.error('檔案讀取失敗:', error);
              this.fieldErrors[field.ffId] = this.$t('檔案處理失敗，請重試');
              this.submitMessage = this.$t('檔案處理失敗，請重試');
              this.isSubmitting = false;
              return;
            }
          } else if (field.fieldType === 2 && Array.isArray(value)) {
            // 多選 - 處理其他選項
            let finalValues = value.map(v => {
              if (v === '__OTHER__' && this.formOtherValues[field.ffId]) {
                return `${this.$t('其他')}：${this.formOtherValues[field.ffId]}`;
              }
              return v;
            });
            fieldData.push({
              ffId: field.ffId,
              value: finalValues.join(', '),
              fileName: null,
              filePath: null
            });
          } else if (field.fieldType === 3 && value === '__OTHER__') {
            // 單選 - 處理其他選項
            const finalValue = this.formOtherValues[field.ffId] 
              ? `${this.$t('其他')}：${this.formOtherValues[field.ffId]}` 
              : this.$t('其他');
            fieldData.push({
              ffId: field.ffId,
              value: finalValue,
              fileName: null,
              filePath: null
            });
          } else {
            // 其他類型
            fieldData.push({
              ffId: field.ffId,
              value: value || '',
              fileName: null,
              filePath: null
            });
          }
        }

        // 準備 JSON 請求資料
        const requestData = {
          fId: this.formData.fId,
          data: fieldData
        };

        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/SubmitForm`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestData)
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.message || this.$t('送出失敗，請稍後再試'));
        }

        const result = await response.json();

        // 使用 SweetAlert 顯示成功訊息
        const message = this.formData.requireApproval 
          ? this.$t('表單已成功送出。您的資料已送出，請等候審核通知。') 
          : this.$t('表單已成功送出，感謝您的填寫。');
        
        await Swal.fire({
          title: this.$t('成功！'),
          text: message,
          icon: 'success',
          confirmButtonText: this.$t('確定')
        });

        // 清空表單
        this.initializeFormValues();

        // 重新載入文章以更新表單狀態（如達到上限）
        this.fetchPostData(this.$route.params.PId);

      } catch (error) {
        console.error('送出表單失敗:', error);
        
        // 使用 SweetAlert 顯示錯誤訊息
        await Swal.fire({
          title: this.$t('錯誤'),
          text: error.message || this.$t('送出失敗，請稍後再試'),
          icon: 'error',
          confirmButtonText: this.$t('確定')
        });
      } finally {
        this.isSubmitting = false;
      }
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';

      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}/${month}/${day}`;
    },

    // 處理內容中的相對路徑 URL
    processContentUrls(content) {
      if (!content) return '';

      const baseUrl = `${this.$store.state.src}${this.$store.state.subDirectory}`;

      // 處理 img 標籤的 src 屬性（相對路徑）
      content = content.replace(
        /<img([^>]*?)src=["'](?!http|https|data:)([^"']+)["']/gi,
        (match, beforeSrc, src) => {
          const fullUrl = src.startsWith('/') ? `${baseUrl}${src}` : `${baseUrl}/${src}`;
          return `<img${beforeSrc}src="${fullUrl}"`;
        }
      );

      // // 處理 a 標籤的 href 屬性（如果需要的話）
      // content = content.replace(
      //   /<a([^>]*?)href=["'](?!http|https|mailto:|tel:|#)([^"']+)["']/gi,
      //   (match, beforeHref, href) => {
      //     const fullUrl = href.startsWith('/') ? `${baseUrl}${href}` : `${baseUrl}/${href}`;
      //     return `<a${beforeHref}href="${fullUrl}"`;
      //   }
      // );

      return content;
    },

    // 取得檔案副檔名
    getFileExtension(filepath) {
      if (!filepath) return '';

      const ext = filepath.split('.').pop().toUpperCase();

      // 常見檔案類型
      const knownTypes = ['PDF', 'DOC', 'DOCX', 'XLS', 'XLSX', 'PPT', 'PPTX', 'ZIP', 'RAR', 'JPG', 'PNG', 'GIF'];

      return knownTypes.includes(ext) ? ext : 'FILE';
    },

    // 分享功能：複製連結或顯示分享選單
    async sharePost() {
      const currentUrl = window.location.href;

      // 如果瀏覽器支援 Web Share API（主要是手機）
      if (navigator.share) {
        try {
          await navigator.share({
            title: this.mainTitle,
            url: currentUrl
          });
        } catch (error) {
          // 使用者取消分享，不需要處理
          if (error.name !== 'AbortError') {
            console.error('分享失敗:', error);
            this.copyToClipboard(currentUrl);
          }
        }
      } else {
        // PC 版：直接複製連結
        this.copyToClipboard(currentUrl);
      }
    },

    // 複製連結到剪貼簿
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        alert(this.$t('連結已複製到剪貼簿'));
      } catch (error) {
        console.error('複製失敗:', error);
        // 備用方法
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          alert(this.$t('連結已複製到剪貼簿'));
        } catch (err) {
          alert(this.$t('複製失敗，請手動複製連結'));
        }
        document.body.removeChild(textArea);
      }
    },

    // 分享至 X (Twitter)
    shareToX() {
      const currentUrl = window.location.href;
      const text = encodeURIComponent(this.mainTitle);
      const url = encodeURIComponent(currentUrl);
      const xShareUrl = `https://twitter.com/intent/tweet?text=${text}&url=${url}`;
      window.open(xShareUrl, '_blank', 'width=600,height=400');
    },

    // 分享至 Facebook
    shareToFB() {
      const currentUrl = window.location.href;
      const url = encodeURIComponent(currentUrl);
      const fbShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
      window.open(fbShareUrl, '_blank', 'width=600,height=400');
    }

  },

}

</script>

<style scoped>
/* 修正核取方塊和單選按鈕的固定尺寸 */
.form_box .form-check-input[type="checkbox"],
.form_box .form-check-input[type="radio"] {
  width: 1.25rem;
  height: 1.25rem;
  min-width: 1.25rem;
  min-height: 1.25rem;
  flex-shrink: 0;
}

/* 字數統計樣式 */
.form_box .word_limit {
  text-align: right;
  font-size: 0.875rem;
  color: #666;
  margin-top: 0.25rem;
  margin-bottom: 0;
}

.form_box .word_limit.full {
  color: #dc3545;
  font-weight: 600;
}

/* 其他選項輸入框樣式 */
.form_box .other_input_box {
  margin-top: 0.75rem;
  margin-left: 0;
  display: block;
}
</style>